import Vue from 'vue'
import 'modules/main-header/main-header.vue'
import 'modules/promo-bar/promo-bar.vue'

export default (el) => new Vue({ el })
